import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../services/auth.service';
import { Socket } from 'ngx-socket-io';
import { SocketService } from 'src/app/services/socket.service';
import { Timer } from 'src/app/interfaces/timer.interface';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  public menus = [
    {title: 'Inicio',        path: '/admin/main'},
    {title: 'Ajuda',         path: '/help'},
    {title: 'Configurações', path: '/settings'},
  ];

  constructor(private service: AuthService, private socket: SocketService) { }

  ngOnInit(): void {
  }

  public logout(): void {
    this.service.logout();
  }

  public sync(): void {
    this.socket.emitEvent('reloadTimers', {} as Timer);
  }
}
